import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import enCommon from './locales/en/common.json'
import enErrors from './locales/en/errors.json'

const resources = {
  en: {
    common: enCommon,
    errors: enErrors
  }
}

i18n.use(initReactI18next).init({
  resources,
  defaultNS: 'common',
  ns: ['common', 'errors'],
  lng: 'en',
  interpolation: {
    escapeValue: false
  }
})

export default i18n
